import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useGalleryArtworks = () => {
  return useQuery({
    queryKey: ['gallery-artworks'],
    queryFn: async () => {
      const { data: artworks, error } = await supabase
        .from('artworks')
        .select(`
          id,
          title,
          description,
          medium,
          dimensions,
          image_url,
          additional_images,
          year,
          estimate_low,
          estimate_high,
          artists (
            id,
            name,
            bio,
            birth_year,
            death_year
          )
        `)
        .not('image_url', 'is', null)
        .not('artists.name', 'is', null)
        .order('created_at', { ascending: false })
        // Load ALL artworks - no limit

      if (error) {
        console.error('Error fetching gallery artworks:', error);
        throw error;
      }

      // Transform the data for gallery display
      return artworks?.map((artwork: any) => {
        const artist = artwork.artists;
        
        return {
          id: artwork.id,
          title: artwork.title,
          description: artwork.description,
          medium: artwork.medium,
          dimensions: artwork.dimensions,
          image: artwork.image_url,
          additional_images: artwork.additional_images ? 
            (Array.isArray(artwork.additional_images) ? artwork.additional_images : 
             typeof artwork.additional_images === 'string' ? JSON.parse(artwork.additional_images) : 
             artwork.additional_images) : null,
          year: artwork.year,
          estimate_low: artwork.estimate_low,
          estimate_high: artwork.estimate_high,
          artistName: artist?.name || 'Unknown Artist',
          artistBio: artist?.bio,
          artistYears: artist?.birth_year && artist?.death_year 
            ? `${artist.birth_year} - ${artist.death_year}`
            : artist?.birth_year 
            ? `${artist.birth_year} - Present`
            : '',
        };
      }) || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}; 